import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import * as Yup from "yup";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import gallery from "../../../../Utils/Images/Gallery Send.png";
import { Link, useNavigate } from "react-router-dom";
import { handleAddPageLinks } from "../../../../APIs/Function/HomePageLinks/AddGetHomepageLinks";
const AddPageLinks = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState([]);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
    link: Yup.string().required("Link is required"),
    file: Yup.mixed().required("Image is required"),
  });

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    link: "",
    file: null,
  });
  const [errors, setErrors] = useState({
    name: "",
    description: "",
    link: "",
    file: "",
  });
  const initialFormData = {
    name: "",
    description: "",
    link: "",
    file: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setPreviewImage(e.target.result); // Set the data URL as the preview image
      };

      reader.readAsDataURL(file); // Read the file as data URL
    } else {
      setPreviewImage(gallery); // Set the placeholder image if no file is selected
    }
    setFormData({
      ...formData,
      file: file,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check for blank spaces in form fields
    const isNameBlank = formData.name.trim() === "";
    const isDescriptionBlank = formData.description.trim() === "";
    const isLinkBlank = formData.link.trim() === "";
    const isFileBlank = !formData.file;

    // Show alerts for blank fields
    if (isNameBlank || isDescriptionBlank || isLinkBlank || isFileBlank) {
      if (isNameBlank) {
        alert("Name cannot be blank.");
      }
      if (isDescriptionBlank) {
        alert("Description cannot be blank.");
      }
      if (isLinkBlank) {
        alert("Link cannot be blank.");
      }
      if (isFileBlank) {
        alert("Image cannot be Empty.");
      }
      return; // Exit the function early if there are blank fields
    }

    try {
      await validationSchema.validate(formData, { abortEarly: false });

      setLoading(true);
      let res = await handleAddPageLinks(formData);

      if (res.s) {
        setLoading(false);
        alert("Data Added Successfully");
        navigate("/pagelinks");
      }

      setFormData(initialFormData);
      setErrors({
        name: "",
        description: "",
        link: "",
        file: "",
      });
    } catch (validationError) {
      const errorMessages = validationError.inner.reduce((acc, error) => {
        acc[error.path] = error.message;
        return acc;
      }, {});

      setErrors(errorMessages);
    }
  };
  useEffect(() => {}, [previewImage]);

  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/pagelinks"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Add Details
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      {/* form */}
      <Container maxWidth="sm" sx={{ mt: "30px" }}>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                fullWidth
                required
                error={errors.name}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={4}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Link"
                name="link"
                value={formData.link}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="file-input">
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100px", height: "100px", mb: "10px" }}>
                    <img
                      height={"100%"}
                      width={"100%"}
                      src={previewImage.length ? previewImage : gallery}
                      alt="preview"
                    />
                  </Box>
                  <Typography>Upload Design Image</Typography>
                  <Typography sx={{ fontFamily: "Chillax Variable" }}>
                    (JPG,PNG,PSD,EPS)
                  </Typography>
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-input"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
};

export default AddPageLinks;
